import immutable from 'immutable'
import _ from 'lodash'
import Guid from 'guid'

import {HISTORY_ADD} from './history.action'

export default (state, action) => {
    switch (action.type) {
        case HISTORY_ADD:
            console.log('trying to add something here')
            // get stuff from the action
            let newHistory = {'someHistory': 'anything really'}
            return state.push(immutable.fromJS(newHistory))
        default:			
            return state
    }
}